export function handleHotData(chartOption, res) {
    if(res.data.code===1) {
      let datas = res.data.data.content.data
      let typeLen = datas.length;
        let hotDataList = res.data.data.content.data[0].data;
        const charOptionTemp = JSON.parse(JSON.stringify(chartOption))
        let newVisiulData = charOptionTemp.visualMap.data;
      let typeArr = [], typeArrOld = []
      for(let n = 0; n < typeLen; n++) {
        typeArr.push(datas[n].name)
      }
      for(let i=0;i<Object.keys(newVisiulData[0]).length;i++) {
        typeArrOld.push(Object.keys(newVisiulData[0])[i])
      }
        //  找差集
      let differenceSet = typeArrOld.filter(item => typeArr.includes(item)===false)
        let isEdit = false;
        for(let i=0;i<newVisiulData.length;i++) {
            for(let j=0;j<hotDataList.length;j++) {
                if(newVisiulData[i].name===hotDataList[j].key) {
                    isEdit = true;
                    newVisiulData[i].value = parseInt(hotDataList[j].value)
                }
            }

          if(typeLen > 1){
            for(let a = 0; a < differenceSet.length; a++) {
              if(differenceSet[a] !== 'name'){
                delete newVisiulData[i][`${differenceSet[a]}`]
              }
            }
            for(let m = 1; m < typeLen; m++) {
              let nameN = datas[m].name
              let obj1 = newVisiulData[i]
              if(datas[m].data[i] && newVisiulData[i].name === datas[m].data[i].key){
                obj1[`${nameN}`] = datas[m].data[i].value;
              }else{
                if(datas[m].data && datas[m].data.length > 0){
                  // 优化：解决地图数据顺序不一样时，赋值失败的问题。
                  for(let b=0;b<datas[m].data.length;b++){
                    if(datas[m].data[b] && newVisiulData[i].name === datas[m].data[b].key){
                      obj1[`${nameN}`] = datas[m].data[i].value;
                    }
                  }
                }
              }
            }
          }
            if(!isEdit) {
                newVisiulData[i].value = 0;
            }
            isEdit=false;
        }
        this.$changeOptionsEV(newVisiulData, "chartOption.visualMap.data", false)
    }
 }
